var map = {
	"./AD.png": 49,
	"./AE.png": 50,
	"./AF.png": 51,
	"./AG.png": 52,
	"./AI.png": 53,
	"./AL.png": 54,
	"./AM.png": 55,
	"./AO.png": 56,
	"./AR.png": 57,
	"./AS.png": 58,
	"./AT.png": 59,
	"./AU.png": 60,
	"./AW.png": 61,
	"./AX.png": 62,
	"./AZ.png": 63,
	"./BA.png": 64,
	"./BB.png": 65,
	"./BD.png": 66,
	"./BE.png": 67,
	"./BF.png": 68,
	"./BG.png": 69,
	"./BH.png": 70,
	"./BI.png": 71,
	"./BJ.png": 72,
	"./BL.png": 73,
	"./BM.png": 74,
	"./BN.png": 75,
	"./BO.png": 76,
	"./BQ.png": 77,
	"./BR.png": 78,
	"./BS.png": 79,
	"./BT.png": 80,
	"./BV.png": 81,
	"./BW.png": 82,
	"./BY.png": 83,
	"./BZ.png": 84,
	"./CA.png": 85,
	"./CC.png": 86,
	"./CD.png": 87,
	"./CF.png": 88,
	"./CG.png": 89,
	"./CH.png": 90,
	"./CI.png": 91,
	"./CK.png": 92,
	"./CL.png": 93,
	"./CM.png": 94,
	"./CN.png": 95,
	"./CO.png": 96,
	"./CR.png": 97,
	"./CU.png": 98,
	"./CV.png": 99,
	"./CW.png": 100,
	"./CX.png": 101,
	"./CY.png": 102,
	"./CZ.png": 103,
	"./DE.png": 104,
	"./DJ.png": 105,
	"./DK.png": 106,
	"./DM.png": 107,
	"./DO.png": 108,
	"./DZ.png": 109,
	"./EC.png": 110,
	"./EE.png": 111,
	"./EG.png": 112,
	"./ER.png": 113,
	"./ES.png": 114,
	"./ET.png": 115,
	"./FI.png": 116,
	"./FJ.png": 117,
	"./FK.png": 118,
	"./FM.png": 119,
	"./FO.png": 120,
	"./FR.png": 121,
	"./GA.png": 122,
	"./GB.png": 123,
	"./GD.png": 124,
	"./GE.png": 125,
	"./GF.png": 126,
	"./GG.png": 127,
	"./GH.png": 128,
	"./GI.png": 129,
	"./GL.png": 130,
	"./GM.png": 131,
	"./GN.png": 132,
	"./GP.png": 133,
	"./GQ.png": 134,
	"./GR.png": 135,
	"./GS.png": 136,
	"./GT.png": 137,
	"./GU.png": 138,
	"./GW.png": 139,
	"./GY.png": 140,
	"./HK.png": 141,
	"./HN.png": 142,
	"./HR.png": 143,
	"./HT.png": 144,
	"./HU.png": 145,
	"./ID.png": 146,
	"./IE.png": 147,
	"./IL.png": 148,
	"./IM.png": 149,
	"./IN.png": 150,
	"./IO.png": 151,
	"./IQ.png": 152,
	"./IR.png": 153,
	"./IS.png": 154,
	"./IT.png": 155,
	"./JE.png": 156,
	"./JM.png": 157,
	"./JO.png": 158,
	"./JP.png": 159,
	"./KE.png": 160,
	"./KG.png": 161,
	"./KH.png": 162,
	"./KI.png": 163,
	"./KM.png": 164,
	"./KN.png": 165,
	"./KP.png": 166,
	"./KR.png": 167,
	"./KW.png": 168,
	"./KY.png": 169,
	"./KZ.png": 170,
	"./LA.png": 171,
	"./LB.png": 172,
	"./LC.png": 173,
	"./LI.png": 174,
	"./LK.png": 175,
	"./LR.png": 176,
	"./LS.png": 177,
	"./LT.png": 178,
	"./LU.png": 179,
	"./LV.png": 180,
	"./LY.png": 181,
	"./MA.png": 182,
	"./MC.png": 183,
	"./MD.png": 184,
	"./ME.png": 185,
	"./MG.png": 186,
	"./MH.png": 187,
	"./MK.png": 188,
	"./ML.png": 189,
	"./MM.png": 190,
	"./MN.png": 191,
	"./MO.png": 192,
	"./MP.png": 193,
	"./MQ.png": 194,
	"./MR.png": 195,
	"./MS.png": 196,
	"./MT.png": 197,
	"./MU.png": 198,
	"./MV.png": 199,
	"./MW.png": 200,
	"./MX.png": 201,
	"./MY.png": 202,
	"./MZ.png": 203,
	"./NA.png": 204,
	"./NC.png": 205,
	"./NE.png": 206,
	"./NF.png": 207,
	"./NG.png": 208,
	"./NI.png": 209,
	"./NL.png": 210,
	"./NO.png": 211,
	"./NP.png": 212,
	"./NR.png": 213,
	"./NU.png": 214,
	"./NZ.png": 215,
	"./OM.png": 216,
	"./PA.png": 217,
	"./PE.png": 218,
	"./PF.png": 219,
	"./PG.png": 220,
	"./PH.png": 221,
	"./PK.png": 222,
	"./PL.png": 223,
	"./PM.png": 224,
	"./PN.png": 225,
	"./PR.png": 226,
	"./PS.png": 227,
	"./PT.png": 228,
	"./PW.png": 229,
	"./PY.png": 230,
	"./QA.png": 231,
	"./RE.png": 232,
	"./RO.png": 233,
	"./RS.png": 234,
	"./RU.png": 235,
	"./RW.png": 236,
	"./SA.png": 237,
	"./SB.png": 238,
	"./SC.png": 239,
	"./SD.png": 240,
	"./SE.png": 241,
	"./SG.png": 242,
	"./SH.png": 243,
	"./SI.png": 244,
	"./SK.png": 245,
	"./SL.png": 246,
	"./SM.png": 247,
	"./SN.png": 248,
	"./SO.png": 249,
	"./SR.png": 250,
	"./SS.png": 251,
	"./ST.png": 252,
	"./SV.png": 253,
	"./SX.png": 254,
	"./SY.png": 255,
	"./SZ.png": 256,
	"./TC.png": 257,
	"./TD.png": 258,
	"./TF.png": 259,
	"./TG.png": 260,
	"./TH.png": 261,
	"./TJ.png": 262,
	"./TK.png": 263,
	"./TL.png": 264,
	"./TM.png": 265,
	"./TN.png": 266,
	"./TO.png": 267,
	"./TR.png": 268,
	"./TT.png": 269,
	"./TV.png": 270,
	"./TW.png": 271,
	"./TZ.png": 272,
	"./UA.png": 273,
	"./UG.png": 274,
	"./UM.png": 275,
	"./US.png": 276,
	"./UY.png": 277,
	"./UZ.png": 278,
	"./VA.png": 279,
	"./VC.png": 280,
	"./VE.png": 281,
	"./VG.png": 282,
	"./VI.png": 283,
	"./VN.png": 284,
	"./VU.png": 285,
	"./WF.png": 286,
	"./WS.png": 287,
	"./YE.png": 288,
	"./YT.png": 289,
	"./ZA.png": 290,
	"./ZM.png": 291,
	"./ZW.png": 292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;